import { createAction } from '@reduxjs/toolkit';
import { EditableElements, EditableTrueType } from 'redux/schemas/models/edit-translations';
import { LectureComponent } from 'redux/schemas/models/lecture-component';
import { CourseOutlineItem } from 'redux/selectors/course-outline/course-outline-item';

type TranslationComponent = {
  type: EditableElements,
  trueType?: EditableTrueType,
  component: LectureComponent | CourseOutlineItem,
};

export const showEditTranslationComponent = createAction<TranslationComponent>('SHOW_EDIT_TRANSLATION_COMPONENT');
export const closeEditTranslationComponent = createAction('CLOSE_EDIT_TRANSLATION_COMPONENT');
